import axios from 'axios';
import cfac22 from '../cfac22';

export const recommendOrgs = async (uid) => {
  try {
    const endpoint = `${cfac22('API_HOST_V2')}/organizations/recommended`;
    const response = await axios.post(
      endpoint,
      { uid },
      {
        headers: {
          'Full-Url': window.location.href,
        },
                withCredentials: true,

      }
    );

    return response.data;
  } catch (error) {
    throw error?.response || error;
  }
};

